(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-cul-blog"]) return;
  try {
    
  document.querySelectorAll('[data-recipe-browser]').forEach((browser) => {
    const input = browser.querySelector('[data-recipe-search]');
    const cards = Array.from(browser.querySelectorAll('[data-recipe-card]'));
    const count = browser.querySelector('[data-recipe-count]');
    const clear = browser.querySelector('[data-recipe-clear]');
    const pagination = browser.querySelector('[data-recipe-pagination]');
    const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const index = cards.map((card) => normalize(card.dataset.recipeText));
    const pageSize = 12;
    const initialPage = window.location.hash.match(/^#recipes-page-(\d+)$/);
    let page = initialPage ? Math.max(1, Number(initialPage[1])) : 1;
    const update = () => {
      const words = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
      const matches = cards.filter((card, i) => words.every((word) => index[i].includes(word)));
      const total = matches.length;
      const pages = Math.ceil(total / pageSize);
      page = Math.min(page, Math.max(1, pages));
      const visible = new Set(matches.slice((page - 1) * pageSize, page * pageSize));
      cards.forEach((card) => { card.hidden = !visible.has(card); });
      count.textContent = (total === 1 ? count.dataset.countOne : count.dataset.countMany).replace('[count]', total);
      browser.querySelector('[data-recipe-empty]').hidden = total !== 0;
      clear.hidden = !input.value;
      pagination.replaceChildren();
      pagination.hidden = pages <= 1;
      const addButton = (label, target, disabled, current = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.disabled = disabled;
        if (current) button.setAttribute('aria-current', 'page');
        if (typeof label === 'number') button.setAttribute('aria-label', pagination.dataset.pageLabel.replace('[page]', label));
        button.addEventListener('click', () => {
          page = target;
          const hash = page > 1 ? '#recipes-page-' + page : '';
          history.replaceState(null, '', location.pathname + location.search + hash);
          update();
          pagination.querySelector('[aria-current="page"]')?.focus({ preventScroll: true });
          browser.scrollIntoView({ behavior: 'instant', block: 'start' });
        });
        pagination.append(button);
      };
      addButton(pagination.dataset.previous, page - 1, page === 1);
      for (let number = 1; number <= pages; number += 1) addButton(number, number, false, number === page);
      addButton(pagination.dataset.next, page + 1, page === pages);
    };
    const resetPage = () => {
      page = 1;
      if (/^#recipes-page-/.test(location.hash)) history.replaceState(null, '', location.pathname + location.search);
      update();
    };
    input.addEventListener('input', resetPage);
    clear.addEventListener('click', () => { input.value = ''; resetPage(); input.focus(); });
    browser.querySelector('[data-recipe-tools]').hidden = false;
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-wholesale-application"] && !Shopify.designMode) return;
  try {
    
  function styleWholesaleApplication() {
    const section = document.getElementById('wholesale-application');
    if (!section || section.dataset.wholesaleLayoutReady === 'true') return;
    section.dataset.wholesaleLayoutReady = 'true';
    const observedRoots = new WeakSet();
    const wholesaleStyles = `
      [data-sizing="form-wrapper"] {
        padding: 0 !important;
        width: 100% !important;
        max-width: none !important;
        border: 0 !important;
        border-radius: 0 !important;
      }
      section:has(> h2) {
        background: #204532;
        padding: 28px 32px !important;
        border-radius: 4px;
        margin: 0 0 30px !important;
        text-align: center !important;
      }
      section:has(> h2) h2 {
        color: #ffffff !important;
        font-size: 28px !important;
        line-height: 1.25 !important;
        letter-spacing: -.02em !important;
        margin: 0 0 10px !important;
        font-weight: 700;
      }
      section:has(> h2) p {
        color: #ffffff !important;
        font-size: 14px !important;
        line-height: 1.7 !important;
        letter-spacing: .01em !important;
        margin: 0 auto !important;
        max-width: 620px;
      }
      section[data-sp-wholesale-success="true"] {
        background: #f1f7f2 !important;
        color: #204532 !important;
        border: 1px solid #c5d7cb !important;
        border-radius: 10px !important;
        padding: 32px 28px !important;
        text-align: center !important;
      }
      section[data-sp-wholesale-success="true"]::before {
        content: "✓";
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        margin: 0 auto 14px;
        border-radius: 50%;
        background: #dcecdf;
        color: #204532;
        font-size: 23px;
        font-weight: 700;
        line-height: 1;
      }
      section[data-sp-wholesale-success="true"] h2 {
        display: block !important;
        box-sizing: border-box !important;
        width: 100% !important;
        min-width: 0 !important;
        align-self: stretch !important;
        color: #204532 !important;
        text-align: center !important;
        margin: 0 auto 10px !important;
        max-width: 100%;
        text-wrap: balance;
      }
      section[data-sp-wholesale-success="true"] p {
        color: #314b3d !important;
        text-align: center !important;
        margin: 0 auto !important;
        max-width: 620px;
      }
      form[data-testid="form"] {
        display: grid !important;
        grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
        gap: 16px 24px !important;
        padding: 0 2px !important;
        margin: 0 !important;
      }
      form > * { grid-column: 1 / -1; min-width: 0; }
      form > div:has(> shop-lead-capture) { margin-bottom: -20px; }
      form > div:has(input[id="company_name"]),
      form > div:has(input[id="custom#website"]),
      form > div:has(input[id="first_name"]),
      form > div:has(input[id="last_name"]),
      form > div:has(input[id="phone_number"]) { grid-column: span 3; }
      form > div:has(input[id="billing_address_address1"]) { grid-column: span 4; }
      form > div:has(input[id="billing_address_address2"]) { grid-column: span 2; }
      form > div:has(input[id="company_tax_id"]),
      form > div:has(input[id="billing_address_phone"]) { grid-column: span 3; }
      form > div:has(input[id="billing_address_first_name"]),
      form > div:has(input[id="billing_address_recipient"]) { display: none !important; }
      form input:not([type="checkbox"]), form select, form textarea {
        font-size: 16px !important;
        letter-spacing: .01em !important;
        border-radius: 4px !important;
      }
      form textarea { box-sizing: border-box !important; width: 100%; min-height: 112px !important; resize: vertical; line-height: 1.6 !important; }
      form label { letter-spacing: .01em !important; color: #536359 !important; }
      form fieldset {
        padding: 0 !important;
        margin: 2px 0 4px !important;
        border: 0;
      }
      form fieldset > legend {
        font-size: 14px !important;
        font-weight: 600 !important;
        padding: 0 0 10px !important;
      }
      form fieldset > div {
        display: flex !important;
        flex-wrap: wrap !important;
        flex-direction: row !important;
        gap: 6px 24px !important;
      }
      form fieldset label {
        display: inline-flex !important;
        align-items: center !important;
        gap: 9px !important;
        box-sizing: border-box !important;
        min-height: 34px;
        width: auto !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        cursor: pointer;
      }
      form fieldset label:focus-within { outline: 2px solid #537c61; outline-offset: 4px; }
      form fieldset label span { font-size: 14px !important; line-height: 1.5 !important; color: #314b3d; }
      form input[type="checkbox"] { width: 15px; height: 15px; accent-color: #204532; }
      form > legend {
        font-size: 18px !important;
        line-height: 1.4 !important;
        font-weight: 600 !important;
        letter-spacing: -.01em !important;
        padding: 26px 0 0 !important;
        margin: 8px 0 0 !important;
        border-top: 1px solid #dce4dd;
      }
      form > div:has(input[id="billing_address_zip"]) {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 24px !important;
      }
      form > div:has(input[id="billing_address_zip"]) > * { width: auto !important; min-width: 0; }
      form button[type="button"] { min-height: 55px; border-radius: 4px !important; }
      form button[data-testid="btn-form-submit"] {
        box-sizing: border-box !important;
        grid-column: 1 / -1 !important;
        justify-self: start !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 234px !important;
        max-width: 100% !important;
        min-height: 50px !important;
        height: 50px !important;
        max-height: 50px !important;
        padding: 0 24px !important;
        margin: 10px 0 0 !important;
        border: 0 !important;
        border-radius: 4px !important;
        background: #116a3a !important;
        color: #ffffff !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        line-height: 20px !important;
        letter-spacing: .01em !important;
      }
      form button[data-testid="btn-form-submit"]:hover { background: #204532 !important; }
      form button[data-testid="btn-form-submit"]:focus-visible { outline: 3px solid #537c61; outline-offset: 4px; }
      form + div { padding: 16px 2px 0 !important; text-align: left !important; }
      form + div p { color: #536359 !important; font-size: 12px !important; line-height: 1.7 !important; }
      form + div a { color: #204532 !important; text-decoration: underline !important; text-underline-offset: 3px; }
      form + div a:focus-visible { outline: 2px solid #537c61; outline-offset: 3px; }
      @media (max-width: 749px) {
        section:has(> h2) { padding: 24px 20px !important; margin-bottom: 24px !important; }
        section:has(> h2) h2 { font-size: 25px !important; }
        section:has(> h2) p { font-size: 13px !important; }
        form[data-testid="form"] { grid-template-columns: minmax(0, 1fr) !important; gap: 16px !important; }
        form > div:has(> shop-lead-capture) { margin-bottom: -16px; }
        form > div:has(input) { grid-column: 1 / -1 !important; }
        form fieldset > div { display: grid !important; grid-template-columns: minmax(0, 1fr); gap: 0 !important; }
        form fieldset label { min-height: 44px; }
        form > legend { padding-top: 22px !important; margin-top: 6px !important; }
        form > div:has(input[id="billing_address_zip"]) { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 16px !important; }
        form > div:has(input[id="billing_address_zip"]) > div:has(input[id="billing_address_zip"]) { grid-column: 1 / -1; }
        form button[data-testid="btn-form-submit"] { width: 100% !important; }
      }
    `;
    function applyLayout() {
      const host = section.querySelector('shopify-forms-embed');
      const root = host && host.shadowRoot;
      if (!root) return false;
      function ensureStyle() {
        const form = root.querySelector('form[data-testid="form"]');
        if (form && form.getAttribute('autocomplete') !== 'on') form.setAttribute('autocomplete', 'on');
        const autofillFields = {
          first_name: 'given-name',
          last_name: 'family-name',
          company_name: 'organization',
          email: 'email',
          billing_address_address1: 'address-line1',
          billing_address_address2: 'address-line2',
          billing_address_city: 'address-level2',
          billing_address_zip: 'postal-code'
        };
        Object.entries(autofillFields).forEach(([id, hint]) => {
          const field = root.querySelector('input[id="' + id + '"]');
          if (field && field.getAttribute('autocomplete') !== hint) field.setAttribute('autocomplete', hint);
        });
        const phoneField = root.querySelector('input[id="billing_address_phone"]');
        if (phoneField && phoneField.getAttribute('inputmode') !== 'tel') phoneField.setAttribute('inputmode', 'tel');
        const taxField = root.querySelector('input[id="company_tax_id"]');
        const phoneRow = phoneField && phoneField.closest('form > div');
        const taxRow = taxField && taxField.closest('form > div');
        if (phoneRow && taxRow && phoneRow.parentElement === taxRow.parentElement && taxRow.nextElementSibling !== phoneRow) {
          phoneRow.before(taxRow);
        }
        const notes = root.querySelector('textarea[name="custom#additional_notes"]');
        if (notes) {
          if (!notes.id) notes.id = notes.name;
          if (notes.getAttribute('aria-labelledby') !== 'label-' + notes.name) notes.setAttribute('aria-labelledby', 'label-' + notes.name);
        }
        const successSection = root.querySelector('section:has(> h2)');
        if (successSection && !root.querySelector('form[data-testid="form"]')) {
          successSection.dataset.spWholesaleSuccess = 'true';
          successSection.setAttribute('role', 'status');
          successSection.setAttribute('aria-live', 'polite');
        }
        if (root.querySelector('#sp-wholesale-layout-styles')) return;
        const style = document.createElement('style');
        style.id = 'sp-wholesale-layout-styles';
        style.textContent = wholesaleStyles;
        root.appendChild(style);
      }
      ensureStyle();
      if (!observedRoots.has(root)) {
        new MutationObserver(ensureStyle).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['autocomplete', 'inputmode'] });
        observedRoots.add(root);
      }
      return true;
    }
    let attempts = 0;
    function retryLayout() {
      if (applyLayout()) return;
      attempts += 1;
      if (attempts < 150) window.setTimeout(retryLayout, 200);
    }
    new MutationObserver(retryLayout).observe(section, { childList: true, subtree: true });
    retryLayout();
  }
  styleWholesaleApplication();
  document.addEventListener('shopify:section:load', styleWholesaleApplication);

  } catch(e) { console.error(e); }
})();
})();
